const HEIC_MIME_TYPES = new Set(['image/heic', 'image/heif'])
const HEIC_FILE_EXTENSIONS = /\.(heic|heif)$/i

export function isHeicFile(file: File): boolean {
  const mimeType = file.type.split(';', 1)[0]?.trim().toLowerCase() ?? ''

  return HEIC_MIME_TYPES.has(mimeType) || HEIC_FILE_EXTENSIONS.test(file.name)
}

export async function normalizeImageFile(file: File): Promise<File> {
  if (!isHeicFile(file)) return file

  const { default: convertHeic } = await import('heic2any')
  const converted = await convertHeic({
    blob: file,
    quality: 0.9,
    toType: 'image/jpeg',
  })
  const blob = Array.isArray(converted) ? converted[0] : converted

  if (!blob) throw new Error('HEIC conversion returned no image')

  return new File([blob], file.name.replace(/\.(heic|heif)$/i, '.jpg'), {
    lastModified: file.lastModified,
    type: 'image/jpeg',
  })
}
